import { Injectable, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { SizeHelperService } from './size-helper.service';
import { ProjectManagerService } from './project-manager.service';
import { StageService } from './stage.service';
import { BuildFloorService } from './build-floor.service';
import { StraightStairService } from './straight-stairs.service';
import { StairLandingStraightService } from './stair-landing-straight.service';
import { StairLandingRightService } from './stair-landing-right.service';
import { StairLandingLeftService } from './stair-landing-left.service';
import { StairLandingBothSidesService } from './stair-landing-both-sides.service';
import { RailingGenerationService } from './railing/services/railing-generation.service';
import { ImageUtilsService } from './image-utils.service';
import { WallBuilderService } from './wall/wall-builder.service';
import { LoadingSpinnerService } from './loading-spinner.service';

@Injectable()
export class DeckHeightService implements OnInit {

  private deckHeight: number;   // in inches
  deckHeightChange: Subject<number> = new Subject<number>();
  deckHeightChanged: Subject<number> = new Subject<number>();

  constructor(
    private stage: StageService,
    private sizeHelperService: SizeHelperService,
    private projectManagerService: ProjectManagerService,
    private buildFloor: BuildFloorService,
    private straightStairService: StraightStairService,
    private stairLandingStraightService: StairLandingStraightService,
    private stairLandingRightService: StairLandingRightService,
    private stairLandingLeftService: StairLandingLeftService,
    private stairLandingBothSidesService: StairLandingBothSidesService,
    private buildWallService: WallBuilderService,
    private railingGeneration: RailingGenerationService,
    private imageUtilsService: ImageUtilsService,
    private loadingSpinnerService: LoadingSpinnerService,
  ) {
  }

  getDeckHeight(): number {
    return this.deckHeight;
  }

  setDeckHeight(value) {
    let numbValue: number = +value;
    this.deckHeight = numbValue;
    this.deckHeightChange.next(numbValue);
  }

  setDeckHeightNoSubjectUpdate(height: number, wallScale: number): { oldHeight: number; oldWallScale: number } {
    const { deckHeight: oldHeight } = this;

    this.loadingSpinnerService.spinnerLoadingListAddPromise('DeckHeightService')
      .then(_ => {
        this.deckHeight = +height;
        const floor = this.stage.getCompoundFloor();
        floor.position.y = this.sizeHelperService.INCHToCM(this.deckHeight);
        this.projectManagerService.setDeckHeight(this.deckHeight);
        this.buildFloor.rescaleSupportPosts();
        this.straightStairService.rescaleStairs();
        this.stairLandingLeftService.rescaleStairs();
        this.stairLandingRightService.rescaleStairs();
        this.stairLandingStraightService.rescaleStairs();
        this.stairLandingBothSidesService.rescaleStairs();
        this.buildWallService.rescaleWalls(wallScale);
        this.railingGeneration.buildRailing(this.railingGeneration.IsVisible());
        this.imageUtilsService.drawTextSprites();
        this.deckHeightChanged.next();
        this.loadingSpinnerService.spinnerLoadingListRemove('DeckHeightService');
      });

    return {
      oldHeight,
      oldWallScale: -wallScale
    };
  }

  ngOnInit() {
    this.deckHeight = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/deck-height.service.ts